module.exports = __webpack_public_path__ + "dlssrvtyy/img/share-vi.jpg?1cb66f34";